import React, { Fragment } from 'react'
import { InstantSearch, ScrollTo } from 'react-instantsearch/dom'
import { compose, withHandlers, withState } from 'recompose'
import styled from 'styled-components'
import { merge, mergeDeepRight, pathOr } from 'ramda'

import { ConfigProvider as JobSearchConfigProvider } from './config'
import Footer from './Footer'
import SearchFilters from './SearchFilters'
import FullSearch from './SearchForm/FullSearch'
import SearchPagination from './SearchPagination'
import SearchResults from './SearchResults'
import SearchStats from './SearchStats'
import { urlToSearchState, searchStateToUrl, createURL, defaultState, DEFAULT_RADIUS } from './utils'

export const BodyWrapper = styled.div`
  background: #f7f7f7;
`

export const Content = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 16px 16px 16px;

  @media (min-width: 768px) {
    margin: 0 32px 32px 32px;
  }

  @media (min-width: 992px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
  }
`
export const SearchResultsArea = styled.div`
  width: 100%;
  @media (min-width: 768px) {
  }

  @media (min-width: 992px) {
    display: flex;
    max-width: 838px;
    flex-direction: column;
  }
`

export const enchanceComponent = compose(
  withState('toggledOn', 'toggle', false),
  withHandlers({ toggle: ({ toggle }) => e => toggle(current => !current) })
)

export class JobSearch extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      searchState: urlToSearchState(this.props.location)
    }
    this.onSearchStateChange = this.onSearchStateChange.bind(this)
    this.updateBrowserUrl = this.updateBrowserUrl.bind(this)
  }
  onSearchStateChange (searchState, { clearAll } = {}) {
    if (clearAll) {
      this.setState({ searchState: { ...defaultState, clearAll: true } })
      return setTimeout(() => {
        this.setState({ searchState: { ...defaultState, clearAll: false } })
        this.props.history.push('/search')
      }, 300)
    }
    const nextState = mergeDeepRight(this.state.searchState, searchState)
    this.setState({ searchState: { ...nextState, clearAll: false } })
    this.updateBrowserUrl(nextState)
  }

  updateBrowserUrl (searchState) {
    const updatedUrl = searchStateToUrl(this.props, searchState)
    this.props.history.push(updatedUrl, searchState)
  }

  render () {
    const { searchState } = this.state
    const { aroundLatLng, aroundRadius = DEFAULT_RADIUS, filters } = pathOr({}, ['configure'], searchState)
    const nextConfig = { aroundLatLng, aroundRadius, filters }
    const searchConfig = merge(defaultState.configure, nextConfig)

    return (
      <InstantSearch
        appId={process.env.REACT_APP_ALGOLIA_APP_ID}
        apiKey={process.env.REACT_APP_ALGOLIA_API_KEY}
        indexName={process.env.REACT_APP_ALGOLIA_INDEX_NAME}
        searchState={searchState}
        onSearchStateChange={this.onSearchStateChange}
        createURL={createURL}>
        <JobSearchConfigProvider config={searchConfig}>
          <Fragment>
            <FullSearch searchState={searchState} onSearchStateChange={this.onSearchStateChange} />
            <BodyWrapper>
              <Content>
                <SearchFilters {...this.props} {...this.state} onSearchStateChange={this.onSearchStateChange} />
                <SearchResultsArea>
                  <SearchStats searchState={searchState} onSearchStateChange={this.onSearchStateChange} />
                  <ScrollTo>
                    <SearchResults />
                    <SearchPagination />
                  </ScrollTo>
                </SearchResultsArea>
              </Content>
            </BodyWrapper>

            <Footer />
          </Fragment>
        </JobSearchConfigProvider>
      </InstantSearch>
    )
  }
}

export default enchanceComponent(JobSearch)
